import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BACKEND_URI } from '../config/config-vars';
import { BoardPerformance } from '../models/board-performance.model';
import { LocationPerformance } from '../models/location-performance.model';
import { ThirtyDaySegment } from '../models/thirty-day-segment.model'; // create if you don’t have it
// optionally: MonthlyPerformance model if you add monthly endpoints later

const BASE_URL = `${BACKEND_URI}/api/performance`;

@Injectable({ providedIn: 'root' })
export class BoardPerformanceService {
  constructor(private http: HttpClient) {}

  // ---- Summaries
  getBoardPerformance(days = 90): Observable<BoardPerformance[]> {
    const params = new HttpParams().set('days', String(days));
    return this.http.get<BoardPerformance[]>(`${BASE_URL}/boards`, { params });
  }

  getLocationPerformance(days = 90): Observable<LocationPerformance[]> {
    const params = new HttpParams().set('days', String(days));
    return this.http.get<LocationPerformance[]>(`${BASE_URL}/locations`, { params });
  }

  // ---- 30-day segments
  getBoardSegments30(assetTag: string, days = 90): Observable<ThirtyDaySegment[]> {
    const params = new HttpParams().set('days', String(days));
    // encode the asset tag for safety
    return this.http.get<ThirtyDaySegment[]>(
      `${BASE_URL}/boards/${encodeURIComponent(assetTag)}/segments30`,
      { params }
    );
  }

  getLocationSegments30(locationId: string, days = 90): Observable<ThirtyDaySegment[]> {
    const params = new HttpParams().set('days', String(days));
    return this.http.get<ThirtyDaySegment[]>(
      `${BASE_URL}/locations/${locationId}/segments30`,
      { params }
    );
  }

  // ---- Exports
  exportToExcelBoard(days = 90): Observable<Blob> {
    const params = new HttpParams().set('days', String(days));
    return this.http.get(`${BASE_URL}/boards/export`, { params, responseType: 'blob' });
  }

  exportToExcelLocation(days = 90): Observable<Blob> {
    const params = new HttpParams().set('days', String(days));
    return this.http.get(`${BASE_URL}/locations/export`, { params, responseType: 'blob' });
  }
}
